import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import WorkIcon from '@material-ui/icons/Work';
import ListItemText from '@material-ui/core/ListItemText';
import { Link, useLocation } from 'react-router-dom';
import * as Routes from '../../../constants/Routes';
import ProtectedSection from '../../ProtectedSection';
import Roles from '../../../constants/Roles';

export default function PacksMenuItem() {
  const location = useLocation();
  return (
    <ProtectedSection roles={[Roles.SuperUser]}>
      <ListItem button component={Link} to={Routes.Packs} selected={location.pathname.startsWith(Routes.Packs)}>
        <ListItemIcon>
          <WorkIcon />
        </ListItemIcon>
        <ListItemText primary="Packs" />
      </ListItem>
    </ProtectedSection>
  );
}
